function CadastrarPerfilTabela({vetor, alterarPerfilModal,editar}) {
    return (
        <div>
            <table className="table">
                <thead>
                    <tr>
                        <th>Nome</th>
                        <th>Editar</th>
                        
                    </tr>
                </thead>
                <tbody>
                    {Array.isArray(vetor) && vetor.map((obj) => {
                        const {id, nome, permissoes} =obj;
                        return(
                            <tr key={id}>
                            <td>{nome}</td>
                            <td>
                                <button
                                onClick ={()=> editar(id, permissoes)}
                                className = 'btn btn-success'>
                                    Editar
                                </button>
                            </td>

                        </tr>
                        );   
                    })}
                </tbody>
            </table>
        </div>
    );
}

export default CadastrarPerfilTabela;